module.exports = __webpack_public_path__ + "img/BlendBuff-Fire.c4201dbe.png";